

const observer = new MutationObserver(mutations => {
  mutations.forEach(({ addedNodes }) => {
    addedNodes.forEach(node => {
      if (node.nodeType === 1) {
        if (node.tagName === "IFRAME") {
          if (node.src.includes("youtube.com") || node.src.includes("vimeo.com")) {
            node.setAttribute("loading", "lazy");
            node.setAttribute("data-src", node.src);
            node.removeAttribute("src");
          }
        } else if (node.tagName === "LINK") {
          
          if (node.href.includes("place") ||
              node.href.includes("stamped") ||
              node.href.includes("freegift") ||
              node.href.includes("vimeo.com")
             ) {
            node.setAttribute("data-href", node.href);
            node.removeAttribute("href");
          }
        } else if (node.tagName === "IMG" && !node.src.includes("data:image") && !node.hasAttribute("loading")) {
          node.setAttribute("loading", "lazy");
        } else if (node.tagName === "SCRIPT") {
           if (node.className === "analytics" || node.className === "boomerang") {
            node.type = "text/lazyload";
          } else if (node.innerHTML.includes("asyncLoad")) {
            node.innerHTML = node.innerHTML
              .replace("if(window.attachEvent)", "document.addEventListener('asyncLazyLoad',function(event){asyncLoad();});if(window.attachEvent)")
              .replace(/, asyncLoad/g, ', function(){}');
          } else if (node.innerHTML.includes("PreviewBarInjector") || node.innerHTML.includes("adminBarInjector")) {
            node.innerHTML = node.innerHTML.replace("DOMContentLoaded", "asyncLazyLoad");
          } else if (
            node.src.includes("assets/storefrontxxx") ||
            node.src.includes("assets/shopify_pay/") ||
            node.src.includes("gdpr_cookie") ||
            node.src.includes("azureedge") ||
            node.src.includes("themes_support") ||
            node.src.includes("minified.js") ||            
            node.src.includes("checker.js")
          ) {
            node.setAttribute("data-src", node.src);
            node.removeAttribute("src");
          } else if (
            node.innerText.includes("tracker") ||
            node.innerText.includes("webPixelsManager") ||
            node.innerText.includes("fera") ||
            node.innerText.includes("gtm.start")
          ) {
            node.type = "text/lazyload";
          }
        }
      }
    });
  });
});


observer.observe(document.documentElement, {
    childList: true,
    subtree: true
});

class ShadowRoot extends HTMLElement {
    constructor() {
        super();

        this._shadowRoot = this.attachShadow({ mode: "open" });
        this._shadowRoot.innerHTML = '<style>:host img { pointer-events: none; position: absolute; top: 0; left: 0; width: 100%; height: 199vh; max-width: 99vw; max-height: 199vh;</style><img id="shadow" alt="lcp_imge"/>';
    }

    connectedCallback() {
        this._fullImageEl = this._shadowRoot.querySelector("#shadow");
        this._fullImageEl.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8000 8000'%3E%3C/svg%3E";
    }
}

customElements.define("shadow-root", ShadowRoot);

document.head.insertAdjacentHTML("afterend", `<shadow-root></shadow-root>`);
